import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  public readonly AUTH_BASE_URL = environment.authApiUrl;

  constructor(private httpClient: HttpClient) {}

  get<T>(endpoint: string, requestParams?: any): Observable<T> {
    const httpParams = this.createHttpParams(requestParams);
    return this.httpClient.get<T>(`${this.AUTH_BASE_URL}${endpoint}`, { params: httpParams });
  }

  post<T>(endpoint: string, requestData: any): Observable<T> {
    return this.httpClient.post<T>(`${this.AUTH_BASE_URL}${endpoint}`, requestData);
  }

  put<T>(endpoint: string, requestData: any): Observable<T> {
    return this.httpClient.put<T>(`${this.AUTH_BASE_URL}${endpoint}`, requestData);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.httpClient.delete<T>(`${this.AUTH_BASE_URL}${endpoint}`);
  }

  private createHttpParams(requestParams: any): HttpParams {
    if (!requestParams) return new HttpParams();

    let httpParams = new HttpParams();
    
    Object.keys(requestParams).forEach(paramKey => {
      const paramValue = requestParams[paramKey];
      if (!this.isValidParamValue(paramValue)) return;
      
      httpParams = httpParams.set(paramKey, paramValue.toString());
    });
    
    return httpParams;
  }

  private isValidParamValue(value: any): boolean {
    return value !== null && value !== undefined;
  }
}